import $ from 'jquery';
import Glider from 'glider-js';
import { Foundation } from '../lib/foundation-explicit-pieces';
import 'slick-carousel/slick/slick.min';

import throttle from 'lodash/throttle';

let glider = null;

const toggleCarousel = () => {
  if (Foundation.MediaQuery.upTo('medium') && !glider) {
    glider = new Glider(document.querySelector('.featured_items'), {
      slidesToShow: 2,
      slidesToScroll: 1,
      draggable: true,
      dots: '.glider-dots',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  } else if (Foundation.MediaQuery.atLeast('large') && glider) {
    glider.destroy();
    glider = null;
  }
};

if (document.querySelector('.featured_items')) {
  $(window).on('changed.zf.mediaquery', () => toggleCarousel());

  toggleCarousel();
}

// Team
const team = $('.team_items');

team.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  draggable: true,
  arrows: false,
  buttons: false,
  infinite: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 639,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

const prev = throttle(() => {
  console.log('prev');
  team.slick('slickPrev');
}, 1000);
const next = throttle(() => {
  console.log('next');
  team.slick('slickNext');
}, 1000);

team.on('wheel', function (e) {
  // e.preventDefault();
  console.log(e.originalEvent.deltaY);
  if (e.originalEvent.deltaY < 0) prev();
  if (e.originalEvent.deltaY > 0) next();
});
